'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useDataGridBody_unstable", {
    enumerable: true,
    get: function() {
        return useDataGridBody_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableBody = require("../TableBody/useTableBody");
const _dataGridContext = require("../../contexts/dataGridContext");
const _tableContext = require("../../contexts/tableContext");
const useDataGridBody_unstable = (props, ref)=>{
    const { sortable } = (0, _tableContext.useTableContext)();
    const getRows = (0, _dataGridContext.useDataGridContext_unstable)((ctx)=>ctx.getRows);
    const sort = (0, _dataGridContext.useDataGridContext_unstable)((ctx)=>ctx.sort.sort);
    const rows = sortable ? sort(getRows()) : getRows();
    const baseState = (0, _useTableBody.useTableBody_unstable)({
        ...props,
        children: null,
        as: 'div'
    }, ref);
    return {
        ...baseState,
        rows,
        renderRow: props.children
    };
};
